import { screen } from '../../../../../../../../../theme/images';
import { StubbornToolboxProperties } from '../../../../../../../../business/StubbornToolboxMapping';

export const toolbox: StubbornToolboxProperties = {
  name: 'sterContainer',
  label: 'Ster Screen',
  category: 'Layouts',
  image: screen,
};
